import React from 'react';
import SubpageLayout from './SubpageLayout';

const cover = (
  <div className="cover cover-doc">
    <svg className="deco" viewBox="0 0 1100 360" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1">
        <rect x="380" y="60" width="340" height="240" rx="14" />
        <rect x="400" y="84" width="240" height="8" rx="3" />
        <rect x="400" y="108" width="300" height="6" rx="3" />
        <rect x="400" y="124" width="280" height="6" rx="3" />
        <rect x="400" y="140" width="290" height="6" rx="3" />
        <rect x="400" y="170" width="180" height="8" rx="3" />
        <rect x="400" y="194" width="300" height="6" rx="3" />
        <rect x="400" y="210" width="270" height="6" rx="3" />
        <rect x="400" y="226" width="290" height="6" rx="3" />
        <rect x="400" y="256" width="120" height="22" rx="6" fill="#9A56FF" fillOpacity="0.8" stroke="none" />
      </g>
    </svg>
  </div>
);

export default function Terms() {
  return (
    <SubpageLayout
      docTitle="Terms — Game Accelerator"
      title="Terms"
      lede="The rules of the road for using Game Accelerator. Plain language where we can manage it; precise legalese where we can't."
      cover={cover}
    >
      <p style={{ color: 'var(--text-3)', fontSize: 14 }}>Last updated: April 12, 2026</p>

      <h2>1. Your account</h2>
      <p>You can use Game Accelerator on up to 5 devices simultaneously per account. You're responsible for keeping your login credentials safe. If you suspect unauthorized access, rotate your password and contact support — we'll help you audit recent sessions.</p>

      <h2>2. Acceptable use</h2>
      <p>Use the service to accelerate your own games. Don't use it to evade bans, distribute malware, run DDoS attacks, scrape, or violate the terms of service of any game you connect to. We log abuse signals (not your traffic content) and will suspend accounts that abuse the platform.</p>

      <h2>3. Subscriptions and refunds</h2>
      <p>Plans are billed monthly or annually. You can cancel any time from your account dashboard — your access continues until the end of the paid period, and you won't be charged again. We honor a <strong>30-day money-back guarantee</strong> on first-time purchases of any annual plan.</p>

      <h2>4. Service availability</h2>
      <p>We target 99.9% uptime across our edge network. Scheduled maintenance is announced 48 hours in advance on our status page. If we miss our SLA in a given month, eligible Elite customers receive prorated credit on their next invoice.</p>

      <h2>5. Limitation of liability</h2>
      <p>Game Accelerator improves the network conditions of your gameplay. We can't guarantee specific match outcomes, ranks, or in-game results. To the fullest extent permitted by law, our liability is limited to the amount you paid us in the prior 12 months.</p>

      <h2>6. Changes</h2>
      <p>If we make material changes to these terms, we'll notify you by email and in-app at least 30 days before they take effect. Continuing to use the service after that means you accept the new terms. The latest version always lives at this URL.</p>
    </SubpageLayout>
  );
}
